<style></style>
<template>
  <!-- Info notice -->
  <div class="infoNotice">
    <div class="blockTitle clearfix">
      <span class="pull-left typeicon">
        <i class="fas fa-info"></i>
      </span>
      <span class="typelabel" v-if="message.typeLabel">Info notice</span>
      <span
        class="name colorNavy"
        v-if="message.user_type != 8 && message.user_type != 9"
        >Info</span
      >
      <span v-if="message.important">
        <i class="fas fa-star colorTrump"></i>
      </span>
      <span v-if="message.is_new" class="newLabel colorTrump">NEW</span>

      <span
        class="pull-right far fa-trash-alt closeNotice"
        @click="hideMessage($event, message.id, $index)"
      ></span>
      <span class="timeAgo">
        <span am-time-ago="message.created_timestamp | amFromUnix"></span>
      </span>
    </div>
    <!-- ng-if='message.images.length > 1' -->
    <div class="limitedDiv">
      <p class="blockText noticeText" v-html="message.message"></p>
    </div>

    <div style="clear: both"></div>
  </div>
</template>
<script>
export default {
  name: "info",
  props: {
    message: Object,
  },
};
</script>
